import { Injectable } from '@angular/core';
import { ResourceService } from '../../shared/resource.service';
import { environment } from '../../../environments/environment';
import { JobReference } from './job-reference';
import { JobReferenceSerializer } from './job-reference.serializer';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class JobReferenceService extends ResourceService<JobReference> {
  baseUrl = environment.serverUrl + 'reference/jobs/';
  allSelected = false;

  constructor(http: HttpClient) {
    super(http, 'reference/jobs/', new JobReferenceSerializer());
  }
}
